import { PLATFORMS } from '../../UserSettings/constants';
export const prospectPlatforms = [
    PLATFORMS.SALESFORCE_LIGHTNING,
    PLATFORMS.SALESFORCE_CLASSIC_ACCOUNT,
    PLATFORMS.HUBSPOT,
    PLATFORMS.SALESFORCE_CLASSIC,
    PLATFORMS.SCOUT,
];
